module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "cells"
  }, [_c('div', {
    staticClass: "cell text-center"
  }, [_c('a', {
    staticClass: "action-back iconfont",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push('/')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "brand",
    attrs: {
      "src": "/static/images/brand-login.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captText),
      expression: "captText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.captText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateCapt($event)
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.captUrl
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "help-text text-right"
  }, [_c('router-link', {
    attrs: {
      "to": "/auth/reset"
    }
  }, [_vm._v("忘记密码")])], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-round",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.btnText))])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('router-link', {
    staticClass: "btn btn-outline",
    attrs: {
      "to": "/auth/register"
    }
  }, [_vm._v("注册")])], 1)])])]), _vm._v(" "), _c('toast', {
    attrs: {
      "show": _vm.toastShow,
      "text": _vm.toastText
    },
    on: {
      "hidden": function($event) {
        _vm.toastShow = false
      }
    }
  }), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-989a27bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/login.vue
// module id = 371
// module chunks = 1